module.exports = __webpack_public_path__ + "static/media/cancun.cd98e2c3.jpg";